import { IBaseCellsProps } from '../../cells.interfaces';
import { StyledTableCell } from '../../CellSingleTextLine/CellSingleTextLine.styles';
import { Skeleton } from '../../../../base-components';

const CellDateAndTimeSkeleton = (props: IBaseCellsProps) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
    } = props;
    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
        >
            <Skeleton width={100} variant="text" />
        </StyledTableCell>
    );
};

export default CellDateAndTimeSkeleton;
